import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LoadingLoader } from "../../components/buttons/button";
import MainContainer from "../../components/maincontainer";
import MainHeader from "../../components/mainheader";
import ConfirmDelete from "../../components/modals/confirm-delete";
import DeletedModal from "../../components/modals/deleted-modal";
import { useNavigate } from "react-router-dom";
import Line from "../../assets/more - vertical.svg";
import { manageExamQuestion } from "../../data/Reducers/ExamReducer";
import Img from "../../assets/tableimg.png";

const Questions = () => {
	const Headers = ["ID", "image", "type", "questions", "Answer", "actions"];
	const tableData = [
		{
			id: "25",
			title: "The Nation",
			language: "English",
			questions: "20",
			active: true,
		},
		{
			id: "25",
			title: "The Nation",
			language: "English",
			questions: "20",
			active: true,
		},
		{
			id: "25",
			title: "The Nation",
			language: "English",
			questions: "20",
			active: true,
		},
		{
			id: "25",
			title: "The Nation",
			language: "English",
			questions: "20",
			active: true,
		},
		{
			id: "25",
			title: "The Nation",
			language: "English",
			questions: "20",
			active: true,
		},
		{
			id: "25",
			title: "The Nation",
			language: "English",
			questions: "20",
			active: true,
		},
	];

	let { exam } = useSelector(s => s),
		[data, setData] = useState(null),
		dispatch = useDispatch();

	useEffect(() => {
		setData(exam?.data);
	}, [exam?.data]);

	useEffect(() => {
		dispatch(manageExamQuestion("get", null));
	}, [dispatch]);

	if (!data && !exam?.data) return <LoadingLoader />;

	return (
		<div>
			<MainHeader text={"Exam"} />
			<MainContainer>
				<h2 className="tw-text-xl tw-text-main tw-font-normal work">Exam</h2>
				<div className="tw-mt-8">
					<ExamTable headers={Headers} data={data?.docs || tableData} />
				</div>
			</MainContainer>
		</div>
	);
};

export default Questions;

const ExamTable = ({ headers, data }) => {
	const [modal, SetModal] = useState(false),
		[actionModal, setActionModal] = useState(""),
		[active, SetActive] = useState(null),
		navigate = useNavigate();
	const handleModal = i => {
			SetActive(i);
			SetModal(!modal);
		},
		handleCloseModal = () => {
			setActionModal("");
		};

	let [datum, setDatum] = useState(null);

	let [loading, setLoading] = useState(null),
		dispatch = useDispatch(),
		{ exam } = useSelector(s => s);

	useEffect(() => {
		if (["deleted"]?.includes(exam?.status)) {
			setActionModal("deleted-modal");
			setDatum(null);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [exam?.status]);

	return (
		<div>
			<table className="tw-w-full tw-table-auto">
				<thead className="tw-w-full tw-h-10 tw-rounded-t-3xl tw-bg-[#E7E7F6]">
					<tr>
						{headers.map((item, i) => (
							<th
								key={i}
								className="tw-text-sm first-letter:tw-uppercase tw-text-[#838080] work tw-px-3">
								{item}
							</th>
						))}
					</tr>
				</thead>
				<tbody className="tw-divide-y-4">
					{data.map((item, i) => (
						<tr
							style={{
								boxShadow: "0px 3px 5px 0px rgba(0, 0, 0, 0.10)",
								marginBottom: "10px !important",
							}}
							key={i}
							className="work tw-bg-white tw-mt-8">
							<td className="tw-text-main tw-font-normal work tw-text-sm tw-text-center">
								{i + 1}
							</td>
							<td className="tw-p-3">
								<img
									src={item?.image?.url || Img}
									alt=""
									className="tw-h-8 tw-mx-auto"
								/>
							</td>
							<td className="tw-text-main tw-font-normal work tw-text-sm tw-text-center">
								{item?.examID?.title}
							</td>
							{/* <td className="tw-text-main tw-font-normal work tw-text-sm tw-text-center">
								{item?.language?.name}
							</td> */}
							<td className="tw-text-main tw-font-normal work tw-text-sm tw-text-center">
								{item?.question}
							</td>
							<td className="tw-text-main tw-font-normal work tw-text-sm tw-text-center">
								{item?.options?.[item?.correctOptionIndex - 1]?.value}
							</td>

							<td className="tw-relative">
								<img
									onClick={() => handleModal(i)}
									src={Line}
									alt=""
									className="tw-mx-auto tw-cursor-pointer"
								/>
								{active === i && modal && (
									<div className="tw-absolute tw-shadow-lg tw-z-[1000] tw-top-8 tw-p-6 tw-right-4  tw-bg-white tw-space-y-2 k2d">
										<h6
											onClick={() =>
												navigate("/exam-module/create-question", {
													state: item,
												})
											}
											className="tw-text-sm tw-cursor-pointer tw-whitespace-nowrap tw-font-semibold tw-uppercase textColor">
											EDIT Exam
										</h6>
										<h6
											onClick={() => {
												setDatum(item);
												setActionModal("delete-modal");
											}}
											className="tw-text-sm tw-cursor-pointer tw-whitespace-nowrap tw-font-semibold tw-uppercase textColor">
											delete Exam
										</h6>
									</div>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{actionModal === "delete-modal" && (
				<ConfirmDelete
					text={"Exam"}
					loading={loading}
					handleClose={handleCloseModal}
					handleNext={async e => {
						e?.preventDefault();
						if (!datum) return;
						setLoading(true);
						await dispatch(manageExamQuestion("delete", datum));
						setLoading(false);
					}}
				/>
			)}
			{actionModal === "deleted-modal" && (
				<DeletedModal text={"Exam"} handleClose={handleCloseModal} />
			)}
		</div>
	);
};
